export default {
  order_status: "https://cadooz.com/bestellstatus",
  order_status_rendered: "https://business.cadooz.com/business/customer/order_status/order_information.do",
  service: {
    de: "https://www.cadooz.com/service/",
    en: "https://www.cadooz.com/en/service/"
  }
};